import axios from "../helpers/bearerAxios";
import { logger } from "./loggingService";

const DIRECT_LAYOUT_AUTOMATE_CAPABILITY = "Direct_Layout_Automate";

const isYesCapabilityValue = (value: unknown): boolean => value === "Yes";

const readField = (record: Record<string, unknown>, names: string[]): unknown => {
    for (const name of names) {
        if (name in record) return record[name];
    }
    return undefined;
};

const collectCapabilityValues = (root: unknown, capabilityName: string): unknown[] => {
    const target = capabilityName.trim().toLowerCase();
    const values: unknown[] = [];

    const visit = (node: unknown): void => {
        if (!node || typeof node !== "object") return;
        if (Array.isArray(node)) {
            node.forEach(visit);
            return;
        }
        const record = node as Record<string, unknown>;
        const name = readField(record, ["capability_name", "Capability_Name", "capabilityName"]);
        if (typeof name === "string" && name.trim().toLowerCase() === target) {
            values.push(readField(record, ["capability_value", "Capability_Value", "capabilityValue"]));
            return;
        }
        Object.values(record).forEach(visit);
    };

    visit(root);
    return values;
};

const isAutomateValueGranted = (value: unknown): boolean => isYesCapabilityValue(value);

/** True only when the oneDRAW user capability Direct_Layout_Automate is Yes. */
export const hasDirectLayoutAutomateCapability = (oneDrawCapabilities: unknown): boolean =>
    collectCapabilityValues(oneDrawCapabilities, DIRECT_LAYOUT_AUTOMATE_CAPABILITY).some(isAutomateValueGranted);

let cachedOneDrawCapabilities: unknown = null;

export const rememberDirectLayoutCapabilityPayloads = (oneDrawCapabilities: unknown): void => {
    cachedOneDrawCapabilities = oneDrawCapabilities;
};

/** Read at generation time. Only a oneDRAW capability value of Yes enables oneDoc Direct Layout. */
export const isDirectLayoutAutomateEnabled = (): boolean =>
    hasDirectLayoutAutomateCapability(cachedOneDrawCapabilities);

const validationTest = async (): Promise<GetUserCapabilityResponse> => {
    try {
        const response = await axios.get(import.meta.env.VITE_GET_USER_CAPABILITY!);
        return response.data;
    } catch (e: any) {
        if (e.response) {
            console.error("Response error:", e.response.status, e.response.data);
        } else if (e.request) {
            console.error("No response received:", e.request);
        } else {
            console.error("Request setup error:", e.message);
        }
        logger.error(e);
        throw e;
    }
}

const userCapabilityService = {
    validationTest
}

export default userCapabilityService;
